import {getBannerInfo} from "../pages/bannerInfo";
import {invoicePhotoDate} from "./invoiceModel";

export function appointmentBannerNotes(notes,appointment) {
  const text=getBannerInfo(appointment).trim();
  if(!appointment?.id || !text)throw new Error("The linked appointment has no Banner info to import.");
  const date=invoicePhotoDate({appointmentId:appointment.id},appointment);
  const block="Banner info from photo appointment"+(date ? " ("+date+")" : "")+":\n"+text;
  const current=String(notes || "");
  if(current.includes(block))return {notes:current,alreadyImported:true};
  const combined=(current.trimEnd() ? current.trimEnd()+"\n\n" : "")+block;
  if(combined.length>4000)throw new Error("Banner info plus existing notes exceeds 4,000 characters. Shorten the job notes or copy the needed details manually.");
  return {notes:combined,alreadyImported:false};
}
